import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  Ch_signPhysiotherapyPrescriptionDocumentInput,
  useChSignPhysiotherapyPrescriptionMutation as useChSignPhysiotherapyPrescriptionMutationType,
} from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChSignPhysiotherapyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChSignPhysiotherapyPrescriptionMutation($input: Ch_signPhysiotherapyPrescriptionDocumentInput!) {
    ch_signPhysiotherapyPrescriptionDocument(input: $input) {
      ch_PhysiotherapyPrescription {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...chPhysiotherapyFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChSignPhysiotherapyPrescriptionMutationType>, "variables"> & {
  id: Ch_signPhysiotherapyPrescriptionDocumentInput["id"]
}

const useChSignPhysiotherapyPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChSignPhysiotherapyPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChSignPhysiotherapyPrescriptionMutation }
